<div class="page-title-area1 page-title-four">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-item">
                <h2>{{ pageTitle }}</h2>
            </div>
        </div>
    </div>
</div>
